var AccountModificationView = $.extend({/* AccountModificationView */}, BaseView, {

	viewSelector: '#account-modification-view',

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {

		$(this.viewSelector).find('.options-type label').click((function (event) {

			if ($(event.currentTarget).attr('for') == 'method-other') {
				$(this.viewSelector).find('.sepa-option').removeClass('hide');
				$(this.viewSelector).find('.non-sepa-option').addClass('hide');
			} else {
				$(this.viewSelector).find('.sepa-option').addClass('hide');
				$(this.viewSelector).find('.non-sepa-option').removeClass('hide');
			}

			$(this.viewSelector).find('.hide-initial-form').removeClass('hide').removeClass('hide-initial-form');

		}).bind(this));

		$(this.viewSelector).find('.input-file input[type=file]').change(this.onChangeInputFile.bind(this));
		$(this.viewSelector).find('#attach-button').click(this.attachFile.bind(this));
	},

	onChangeInputFile: function(event) {

		var path = $(event.currentTarget).val();
		var fileName = path.match(/[^\/\\]+$/);

		$(this.viewSelector).find('.input-file input[type=text]').val(fileName);

		if (path != '') {
			$(this.viewSelector).find('#attach-button').removeClass('hide');
		} else {
			$(this.viewSelector).find('#attach-button').addClass('hide');
		}
	},

	attachFile: function(event) {
		event.preventDefault();

		// Create of files text list
		if ($(this.viewSelector).find('.input-file .files-list ul').length == 0) {
			$(this.viewSelector).find('.input-file .files-list').append('<ul></ul>');
		}

		// Create new input file cloning last input file
		var numFiles = $(this.viewSelector).find('.input-file .files-list ul > li').length;
		var clone = $(this.viewSelector).find('#input-document-' + numFiles).clone();
			clone.attr('id', 'input-document-' + (numFiles + 1));
		$(this.viewSelector).find('.input-file-wrapper').prepend(clone);

		// Binding change event to new input file
		$(this.viewSelector).find('#input-document-' + (numFiles + 1)).change(this.onChangeInputFile.bind(this))

		// Hide input file attached
		$(this.viewSelector).find('#input-document-' + numFiles).addClass('hidden');

		// Add to text list
		$(this.viewSelector).find('.input-file .files-list ul').append('<li>' + $(this.viewSelector).find('.input-file input[type=text]').val() + '</li>');
		$(this.viewSelector).find('.input-file .files-list').removeClass('hide');

		// Reset input with file name
		$(this.viewSelector).find('.input-file input[type=text]').val('');

		// Hide attach button
		$(this.viewSelector).find('#attach-button').addClass('hide');
	}
})